<template>
  <el-dialog
    title="选择客户保养设备"
    :visible.sync="visible"
    width="500px"
    @close="$emit('update:show', false)"
    @open="filterDevices"
  >
    <el-table
      @selection-change="handleDeviceSelectionChange"
      :data="showDevices"
      stripe
      style="width: 100%"
    >
      <div slot="empty">
        客户无设备信息，请先添加客户设备，
        <router-link
          :to="'/dashboard/customers/' + customerID + '?tab=4'"
          >点击前往</router-link
        >
      </div>

      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column label="机型分类">
        <template slot-scope="scope">
          <span>{{ scope.row.item_category.name }}</span>
        </template>
      </el-table-column>
      <el-table-column label="机型">
        <template slot-scope="scope">
          <span>{{ scope.row.machine_type }}</span>
        </template>
      </el-table-column>

      <el-table-column prop="serial_number" label="序列号"></el-table-column>
    </el-table>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button size="small" type="primary" @click="submit">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    devices: {
      type: Array,
      default: () => []
    },
    selection: {
      type: Array,
      default: () => []
    },
    customerID: {
      type: Number,
      default: 0
    }
  },
  watch: {
    show() {
      this.visible = this.show
    }
  },
  data() {
    return {
      visible: this.show,
      selectionTmp: [],
      showDevices: []
    }
  },
  created() {},
  methods: {
    handleDeviceSelectionChange(value) {
      this.selectionTmp = value
    },
    submit() {
      this.visible = false
      this.$emit('selected', this.selectionTmp)
    },
    filterDevices() {
      if (this.selection.length == 0) {
        this.showDevices = this.devices
      } else {
        this.showDevices = this.devices.filter(i => {
          return !this.selection.some(j => i.id == j.id)
        })
      }
    }
  }
}
</script>